module.exports = __webpack_public_path__ + "img/LTS_BW.94dd4143.gif";